import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import StyledText from '../../Generic/Text/StyledText';
import StyledCloseButton from '../../Generic/Buttons/StyledCloseButton';

const StyledNavLink = styled.span`
    height: 32px;
    border-radius: 3px;
    border: ${({ theme }) => `1px solid ${theme.colors.charcoal60}`};
    color: ${({ theme }) => theme.colors.charcoal100};
    position: relative;
    margin-right: 7px;
    padding-right: 8px;
    padding-left: 10px;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    text-transform: capitalize;
    cursor: pointer;
    ${forTablet`
        margin-bottom: 5px;
    `}
`;

const StyledLabel = styled(StyledText)`
    margin: 0 auto;
`;

export type RemoveFilterFunc = () => void;

interface AppliedFilterItemProps {
    name: string;
    removeFilterFunc: RemoveFilterFunc;
}

const AppliedFilterItem: FC<AppliedFilterItemProps> = ({ name, removeFilterFunc }): ReactElement => (
    <StyledNavLink onClick={removeFilterFunc}>
        <StyledCloseButton />
        <StyledLabel textType="button">{name}</StyledLabel>
    </StyledNavLink>
);
export default AppliedFilterItem;
